// Services
import { getKYCFlowDataService } from '../services/kyc.service';
// Types
import { KycApiResponseType } from '../types/kyc-details-api-response.type';

const getKYCFlowDataResolver = async (): Promise<[KycApiResponseType] | [null, boolean]> => {
  const [response] = await getKYCFlowDataService();

  return response?.methods?.length > 0 ? [response] : [null, true];
};

export { getKYCFlowDataResolver };
